const API_ADMIN = process.env.VUE_APP_API_ADMIN_LOCATION;

export default {
  getAll() {
    return new Promise((resolve, reject) => {
      window.axios
        .get(`${API_ADMIN}user/blocked-provider`, {
          headers: {
            ignoreLoading: true,
          },
        })
        .then(({ data }) => {
          resolve(data.data || []);
        })
        .catch(reject);
    });
  },
  create(body) {
    return new Promise((resolve, reject) => {
      window.axios
        .post(`${API_ADMIN}user/blocked-provider`, body)
        .then(({ data }) => resolve(data))
        .catch(reject);
    });
  },
  delete(id) {
    return new Promise((resolve, reject) => {
      window.axios
        .delete(`${API_ADMIN}user/blocked-provider/${id}`)
        .then(({ data }) => resolve(data))
        .catch(reject);
    });
  },
};
